import React from 'react';
import { Button, useTheme } from '@mui/material';

const SecondaryButton = ({ children, ...props }) => {
  const theme = useTheme();

  const accent = theme.palette.accent?.main || '#CB6423';
  const hoverColor = '#9f471a'; // darker than before for stronger contrast

  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        my: 2,
        px: 2.5,

        height: 36,
        minHeight: 36,
        maxHeight: 36,
        lineHeight: 1,

        minWidth: 'unset',
        width: 'fit-content',

        textTransform: 'uppercase',
        fontWeight: 600,

        backgroundColor: accent,
        color: '#fff',
        boxShadow: 'none',

        transition: 'all 150ms ease',

        '&:hover': {
          backgroundColor: hoverColor,

          // 🔥 stronger visual lift (but no movement)
          boxShadow: `0 8px 20px ${accent}55`,
          filter: 'brightness(1.05)'
        }
      }}>
      {children}
    </Button>
  );
};

export default SecondaryButton;
